import { create } from "zustand";
import { CustomerDetailsTab } from "types/model/customer";
import { AiccLanguage, AiccSubUserDetail } from "types/model/aiccCustomer";
import { SubUserDetailTab } from "./AiccCustomer/SubUser/SubUserDetail/constants";

export interface SubUserDetailActiveTab {
  subUserId: string;
  tab: SubUserDetailTab;
}

export interface SubUserDetailActiveLanguage {
  subUserId: string;
  languageId?: number;
}

interface AICCState {
  pendingCustomerDetailTab?: CustomerDetailsTab;
  setPendingCustomerDetailTab: (tab?: CustomerDetailsTab) => void;
  languages: AiccLanguage[];
  setLanguages: (languages: AiccLanguage[]) => void;
  subUserDetailTab?: SubUserDetailActiveTab;
  setSubUserDetailTab: (subUserDetailTab: SubUserDetailActiveTab) => void;
  subUserDetailLanguage?: SubUserDetailActiveLanguage;
  setSubUserDetailLanguage: (subUserDetailLanguage: SubUserDetailActiveLanguage) => void;
  cachedSubUserDetail?: AiccSubUserDetail;
  setCachedSubUserDetail: (subUser?: AiccSubUserDetail) => void;
}

export const useAICCStore = create<AICCState>((set) => ({
  pendingCustomerDetailTab: undefined,
  setPendingCustomerDetailTab: (tab) => set({ pendingCustomerDetailTab: tab }),
  languages: [],
  setLanguages: (languages) => set({ languages }),
  subUserDetailTab: undefined,
  setSubUserDetailTab: (subUserDetailTab) => set({ subUserDetailTab }),
  subUserDetailLanguage: undefined,
  setSubUserDetailLanguage: (subUserDetailLanguage) => set({ subUserDetailLanguage }),
  cachedSubUserDetail: undefined,
  setCachedSubUserDetail: (cachedSubUserDetail) => set({ cachedSubUserDetail }),
}));
